import { genericMemo } from '../../utils';
import { ListItemStyled, ListStyled } from './List.styles';
import { ListProps } from './List.types';

export const List = genericMemo(<T,>({ items, noDataContent, loading, getListItemContent }: ListProps<T>) => {
  return (
    <ListStyled>
      {loading?.value &&
        Array.from({ length: loading.skeletonCount ?? 5 }).map((_, index) => (
          <ListItemStyled key={index}>{loading.getSkeletonContent(index)}</ListItemStyled>
        ))}

      {!loading?.value &&
        (items.length
          ? items.map((item, index) => <ListItemStyled key={index}>{getListItemContent(item, index)}</ListItemStyled>)
          : noDataContent)}
    </ListStyled>
  );
});
